'use client'

import { AuthContextType, User } from '@/@types'
import React, { useEffect } from 'react'
// import PropTypes from 'prop-types'
import { createContext, useState } from 'react'
// import { useLocation, useNavigate } from "react-router-dom"
import axios from '../utils/axiosConfig'

const AuthContext = createContext<AuthContextType>({
  auth: null,
  setAuth: () => {},
  persist: false,
  setPersist: () => {},
})

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [auth, setAuth] = useState<User | null>(null)
  const [persist, setPersist] = useState(false)
  useEffect(() => {
    // https://stackoverflow.com/a/76376124/3110474
    const storedPersist = JSON.parse(localStorage.getItem('persist') || 'false')
    setPersist(storedPersist)
    // TODO: Check if cookie exists or not, if cookie doesn't exist, then no need to call the refreshToken
    // Only attempt refresh if not authenticated and persistence is enabled
    if (!auth && storedPersist) {
      axios.defaults.withCredentials = true
      axios
        .get('/users/refresh-access-token', { withCredentials: true })
        .then((response) => {
          if (response.data && response.data.id) {
            setAuth({
              ...response?.data,
              isAdmin: response?.data?.roles?.some((r: any) => r.role?.name === 'ADMIN'),
              isAuthor: response?.data?.roles?.some((r: any) => r.role?.name === 'AUTHOR'),
              isApprover: response?.data?.roles?.some((r: any) => r.role?.name === 'REVIEWER'),
            })
          } else {
            console.log('No auth data, setting null')
            setAuth(null)
          }
        })
        .catch((error) => console.error('Not logged in: ', error))
    }
  }, [auth])

  return <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>{children}</AuthContext.Provider>
}

export default AuthContext
